import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import apiConfig from "../config/apiConfig";
import { FaMicrophone, FaPaperclip , FaFileAlt } from "react-icons/fa"; // آیکن‌های ضبط صوت و انتخاب فایل



// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Input,
  Button,
} from "reactstrap";

function TicketMessages() {
  const location = useLocation(); // دریافت state که شامل ticketid است
  const { ticketid, source } = location.state || {}; // استخراج ticketid و source
  const [messages, setMessages] = useState([]); // پیام‌ها
  const [newMessage, setNewMessage] = useState(""); // پیام جدید کاربر
  const [loading, setLoading] = useState(true); // وضعیت بارگذاری
  const serverUrl = apiConfig.serverUrl;
  const [userId, setUserId] = useState(null);
  const [playerId, setPlayerId] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null); // تعریف متغیر برای فایل انتخاب‌شده

  const [isRecording, setIsRecording] = useState(false); // وضعیت ضبط صوت
const [audioBlob, setAudioBlob] = useState(null); // داده صوتی ضبط‌شده
const [audioUrl, setAudioUrl] = useState(null); // آدرس پیش‌نمایش صوتی
const mediaRecorderRef = useRef(null); // مرجع MediaRecorder
const audioChunksRef = useRef([]); // آرایه‌ای برای ذخیره قطعات صوتی

const [contextMenu, setContextMenu] = useState(null); // مدیریت منوی زمینه
const [editingMessage, setEditingMessage] = useState(null); // پیام در حال ویرایش
const [isDisabled, setIsDisabled] = React.useState(0);
const [isSending, setIsSending] = useState(false); // وضعیت ارسال پیام
const [sendProgress, setSendProgress] = useState(0); // درصد پیشرفت ارسال
const [isSendingVoice, setIsSendingVoice] = useState(false); // وضعیت ارسال پیام صوتی
const [sendVoiceProgress, setSendVoiceProgress] = useState(0); // درصد پیشرفت ارسال پیام صوتی



  // دریافت پیام‌های تیکت از سرور
  useEffect(() => {
    if (ticketid) {
      axios
        .get(`${serverUrl}get-ticket-messages-panel`, {
          headers: {
            "ticket_id": ticketid,
            "source": source,
          },
        })
        .then((response) => {
          const messagesData = response.data.TicketMessages;
          const Ticket = response.data.Ticket;
          const player_id = response.data.User.player_id;
          setPlayerId(player_id)
          if(Ticket.status == 'closed')
          {
            setIsDisabled(1)
          }
  
          // یافتن اولین sender_id که sender_type برابر با "user" است
          const userMessage = messagesData.find((msg) => msg.sender_type === "user");
          if (userMessage) {
            setUserId(userMessage.sender_id); // ذخیره user_id
          }
          else
          {
            const userMessage = messagesData.find((msg) => msg.receiver_type === "user");
            setUserId(userMessage.receiver_id); // ذخیره user_id
          }
  
          // فرمت کردن پیام‌ها
          const formattedMessages = messagesData.map((msg) => ({
            id: msg.id,
            text: msg.message,
            audio: msg.audio || null, // آدرس فایل صوتی (در صورتی که وجود دارد)
            file_path: msg.file_path || null,
            sender: msg.sender_type === "user" ? "user" : "support",
            date: msg.date,
            time: msg.time,
            isRead: msg.status || false,
          }));


  
          setMessages(formattedMessages); // تنظیم پیام‌ها
          setLoading(false); // پایان بارگذاری
        })
        .catch((error) => {
          console.error("خطا در دریافت پیام‌های تیکت:", error);
          setLoading(false); // پایان بارگذاری حتی در صورت خطا
        });
    }
  }, [ticketid]);
  useEffect(() => {
    const handleClickOutside = () => {
      setContextMenu(null);
    };
    window.addEventListener("click", handleClickOutside);
    return () => {
      window.removeEventListener("click", handleClickOutside);
    };
  }, []);
  
  const toggleReadStatus = (message) => {
    const formData = new FormData();
    formData.append("id", message.id);
    formData.append("isRead", !message.isRead ? 'seen' : 'not_seen'); // تغییر وضعیت خوانده‌شده
    formData.append("source", source); 
    axios
      .post(`${serverUrl}toggle-read-status-panel`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(() => {
        // به‌روزرسانی وضعیت پیام در رابط کاربری
        setMessages(
          messages.map((msg) =>
            msg.id === message.id ? { ...msg, isRead: !message.isRead } : msg
          )
        );
      })
      .catch((error) => {
        console.error("خطا در تغییر وضعیت پیام:", error);
      });
  };

  
  const handleContextMenu = (event, message, messageIndex) => {
    if (message.sender === "support") {
      event.preventDefault();
  
      // دریافت مرجع پیام کلیک‌شده
      const messageElement = document.getElementById(`message-${messageIndex}`);
      if (!messageElement) return;
  
      const messageRect = messageElement.getBoundingClientRect();
  
      // محاسبه موقعیت منو (بالای پیام)
      const x = messageRect.left + 10; // کمی فاصله از سمت چپ پیام
      const y = messageRect.top - 10; // کمی فاصله از بالای پیام
  
      setContextMenu({
        x,
        y,
        message,
      });
    }
  };
  
  
  
  
  const handleDeleteMessage = (message) => {
   
    
    
    setMessages(messages.filter((msg) => msg !== message)); // حذف پیام
    setContextMenu(null);

    const formData = new FormData();
      formData.append("id", message.id); 
      formData.append("source", source); 

      // ارسال پیام به سرور
      axios
        .post(`${serverUrl}delete-message-ticket-panel`, formData, {
          headers: {
            "Content-Type": "multipart/form-data", // تعیین نوع محتوا
          },
        })
        .then(() => {
         
        })
        .catch((error) => {
          console.error("خطا:", error);
        });


  };
  
  
  const handleEditMessage = (message) => {
    
    
    setEditingMessage(message);
    setNewMessage(message.text); // متن ویرایش‌شده را به ورودی منتقل کنید
    setContextMenu(null);
  };
  
  
  const handleSaveEdit = () => {
    setMessages(
      messages.map((msg) =>
        msg === editingMessage ? { ...msg, text: newMessage } : msg
      )
    );
    setEditingMessage(null);
    setNewMessage("");
  };
  
  
  // تابع برای ارسال پیام جدید
  const handleSendMessage = () => {
    if (newMessage.trim() || selectedFile) { // اگر متن یا فایل وجود داشته باشد
     
     if(editingMessage)
    {
      if (editingMessage) {
        setIsSending(true);
        setSendProgress(0);
        
        const formData = new FormData();
        formData.append("id", editingMessage.id); // شناسه پیام ویرایش‌شده
        formData.append("message", newMessage); // متن جدید پیام
        formData.append("source", source); 
        // ارسال پیام ویرایش‌شده به سرور
        axios
          .post(`${serverUrl}edite-message-ticket-panel`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress: (progressEvent) => {
              if (progressEvent.total) {
                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                setSendProgress(Math.min(percentCompleted, 99)); // حداکثر 99% تا پاسخ سرور
              } else if (progressEvent.loaded > 0) {
                setSendProgress(prev => Math.min(prev + 10, 90));
              }
            },
          })
          .then(() => {
            setSendProgress(100);
            // به‌روزرسانی پیام‌ها در لیست
            setMessages(
              messages.map((msg) =>
                msg.id === editingMessage.id ? { ...msg, text: newMessage } : msg
              )
            );
            setEditingMessage(null); // خروج از حالت ویرایش
            setNewMessage(""); // پاک کردن ورودی متن
            setTimeout(() => {
              setIsSending(false);
              setSendProgress(0);
            }, 500);
          })
          .catch((error) => {
            console.error("خطا در ویرایش پیام:", error);
            setIsSending(false);
            setSendProgress(0);
          });
      }
    }
    else
    {
      setIsSending(true);
      setSendProgress(0);
  
      // ساخت FormData برای ارسال پیام
      const formData = new FormData();
      formData.append("message", newMessage); // متن پیام
      formData.append("sender_id", 1); // شناسه پشتیبانی
      formData.append("sender_type", "support"); // نوع فرستنده
      formData.append("receiver_id", userId); // شناسه کاربر
      formData.append("receiver_type", "user"); // نوع گیرنده
      formData.append("ticket_id", ticketid); // شناسه تیکت
      formData.append("source", source); 

  
      // اگر فایلی انتخاب شده باشد، به فرم دیتا اضافه کن
      if (selectedFile) {
        formData.append("file", selectedFile); // فایل انتخابی
      }
  
      // ارسال پیام به سرور
      axios
        .post(`${serverUrl}send-message-ticket-panel`, formData, {
          headers: {
            "Content-Type": "multipart/form-data", // تعیین نوع محتوا
          },
          onUploadProgress: (progressEvent) => {
            if (progressEvent.total) {
              const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
              setSendProgress(Math.min(percentCompleted, 99)); // حداکثر 99% تا پاسخ سرور
            } else if (progressEvent.loaded > 0) {
              // اگر total موجود نباشد اما loaded موجود باشد
              setSendProgress(prev => Math.min(prev + 10, 90));
            }
          },
        })
        .then((response) => {
          setSendProgress(100);
          
          const newMsg = {
            id: response.data.msg_id,
            sender: "support", // پیام جدید از طرف پشتیبانی ارسال می‌شود
            text: newMessage,
            file_path: response.data.file_path || null, // ذخیره مسیر فایل
            date: new Date().toLocaleDateString("fa-IR"), // تاریخ امروز
            time: new Date().toLocaleTimeString("fa-IR"), // زمان کنونی
          };
        
          setMessages([...messages, newMsg]); // اضافه کردن پیام به لیست پیام‌ها
          setNewMessage(""); // پاک کردن پیام متنی
          setSelectedFile(null); // پاک کردن فایل انتخابی بعد از ارسال
          console.log("پیام با فایل ارسال شد!");
        
          // ارسال نوتیفیکیشن به صورت اختیاری - اگر خطا داد، نادیده گرفته می‌شود
          try {
          const notificationData = {
            app_id: "07b91e04-ff96-49fb-b75f-900a17205c78",
            include_subscription_ids: [playerId], // ارسال فقط به این کاربر
            headings: { en: "🔥 پیام جدید!" },
            contents: { en: "شما یک پیام جدید دارید!" },
            url: "https://app.aryadiet.com/",  
          };
        
          fetch("https://onesignal.com/api/v1/notifications", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization:
                "Basic os_v2_app_a64r4bh7sze7xn27safboic4paseg7gx4rpuaa4tgqi5x3kskce2mkll2hpvtsa3kkg5ns22axkl7r4s4ma3rkceyyzxzsd5bpqthha",
            },
            body: JSON.stringify(notificationData),
          })
            .then((notificationResponse) => notificationResponse.json())
            .then((result) => {
              console.log("Notification Response:", result);
            })
            .catch((error) => {
                // خطای نوتیفیکیشن را نادیده می‌گیریم
                console.log("خطا در ارسال نوتیفیکیشن (نادیده گرفته شد):", error);
            });
          } catch (error) {
            // خطای نوتیفیکیشن را نادیده می‌گیریم
            console.log("خطا در ارسال نوتیفیکیشن (نادیده گرفته شد):", error);
          }
          
          setTimeout(() => {
            setIsSending(false);
            setSendProgress(0);
          }, 500);
        })
        .catch((error) => {
          console.error("خطا در ارسال پیام:", error);
          setIsSending(false);
          setSendProgress(0);
        });
    }
    }
  };
  

  const startRecording = () => {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices
        .getUserMedia({ audio: true })
        .then((stream) => {
          mediaRecorderRef.current = new MediaRecorder(stream);
          mediaRecorderRef.current.ondataavailable = (event) => {
            audioChunksRef.current.push(event.data);
          };
          mediaRecorderRef.current.onstop = () => {
            const audioBlob = new Blob(audioChunksRef.current, { type: "audio/wav" });
            const audioUrl = URL.createObjectURL(audioBlob);
            setAudioBlob(audioBlob);
            setAudioUrl(audioUrl);
            audioChunksRef.current = [];
          };
          mediaRecorderRef.current.start();
          setIsRecording(true);
        })
        .catch((err) => {
          console.error("خطا در دسترسی به میکروفون:", err);
        });
    } else {
      alert("میکروفون در دسترس نیست.");
    }
  };
  
  const stopRecording = () => {
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
      setIsRecording(false);
    }
  };
  
  const discardVoiceMessage = () => {
    setAudioBlob(null);
    setAudioUrl(null);
  };

  
  const handleSendVoiceMessage = () => {
    if (audioBlob) {
      setIsSendingVoice(true);
      setSendVoiceProgress(0);

      const formData = new FormData();
      formData.append("audio", audioBlob, "voice_message.wav");
      formData.append("sender_id", 1);
      formData.append("sender_type", "support");
      formData.append("receiver_id", userId);
      formData.append("receiver_type", "user");
      formData.append("ticket_id", ticketid);
      formData.append("source", source); 
  
      axios
        .post(`${serverUrl}send-voice-message-ticket-panel`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            if (progressEvent.total) {
              const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
              setSendVoiceProgress(Math.min(percentCompleted, 99)); // حداکثر 99% تا پاسخ سرور
            } else if (progressEvent.loaded > 0) {
              setSendVoiceProgress(prev => Math.min(prev + 10, 90));
            }
          },
        })
        .then((response) => {
          setSendVoiceProgress(100);
          
          console.log("پاسخ سرور برای پیام صوتی:", response.data);
  
          // اضافه کردن آدرس صوت از سرور به لیست پیام‌ها
          setMessages([
            ...messages,
            {
              sender: "support",
              text: "پیام صوتی ارسال شد.",
              audio: response.data.data.audio_url, // دریافت آدرس از سرور
              date: new Date().toLocaleDateString("fa-IR"),
              time: new Date().toLocaleTimeString("fa-IR"),
            },
          ]);
  
          discardVoiceMessage();
          
          setTimeout(() => {
            setIsSendingVoice(false);
            setSendVoiceProgress(0);
          }, 500);
        })
        .catch((error) => {
          console.error("خطا در ارسال پیام صوتی:", error);
          setIsSendingVoice(false);
          setSendVoiceProgress(0);
        });
    } else {
      alert("لطفاً یک پیام صوتی ضبط کنید.");
    }
  };
  
  
  

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle style={{ textAlign: "right" }} tag="h4">
                  پیام‌های تیکت
                </CardTitle>
              </CardHeader>
              <CardBody style={{ maxHeight: "500px", overflowY: "auto", backgroundColor: "#f8f9fa" }}>
                {loading ? (
                  <div style={{ textAlign: "center" }}>در حال بارگذاری...</div>
                ) : messages.length === 0 ? (
                  <div style={{ textAlign: "center" }}>هیچ پیامی یافت نشد.</div>
                ) : (
                  <div style={{ padding: "10px" }}>
     {messages.map((message, index) => (
  <div
    key={index}
    id={`message-${index}`}
    onContextMenu={(event) => handleContextMenu(event, message, index)}
    style={{
      textAlign: message.sender === "user" ? "left" : "right",
      marginBottom: "10px",
    }}
  >
    <div
      style={{
        display: "inline-block",
        padding: "10px",
        borderRadius: "10px",
        backgroundColor: message.sender === "user" ? "#d1e7dd" : "#d6d8db",
        maxWidth: "70%",
        position: "relative", // موقعیت نسبی برای قرار دادن آیکون
      }}
    >
      {message.audio ? (
        <audio controls>
          <source src={message.audio} type="audio/wav" />
          Your browser does not support the audio element.
        </audio>
      ) : null}
      {message.text && <div>{message.text}</div>}
      
      {message.file_path && (
  <>
    {/* بررسی صحت فرمت JSON */}
    {(() => {
      let filePaths = message.file_path;
      
      // اگر داده‌ها یک رشته JSON معتبر باشند
      try {
        if (filePaths && filePaths.startsWith('[')) {
          filePaths = JSON.parse(filePaths); // تبدیل به آرایه JSON
        } else {
          filePaths = [filePaths]; // اگر رشته واحد باشد، آن را داخل آرایه قرار می‌دهیم
        }
      } catch (e) {
        console.error('Error parsing file paths:', e);
        filePaths = []; // اگر مشکل داشت، یک آرایه خالی قرار می‌دهیم
      }

      // نمایش فایل‌ها
      return filePaths.map((file, fileIndex) => (
        <div
          key={fileIndex}
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: "10px",
            backgroundColor: "#f1f1f1",
            borderRadius: "8px",
            padding: "8px 12px",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            transition: "transform 0.3s ease, box-shadow 0.3s ease",
            cursor: "pointer",
          }}
          onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.05)"}
          onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
        >
          {/* آیکون فایل */}
          <FaFileAlt
            style={{
              color: "#007bff",
              marginRight: "10px",
              fontSize: "18px",
            }}
          />
          {/* نمایش نام فایل */}
          <a
            href={file}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#007bff",
              textDecoration: "none",
              fontWeight: "bold",
              fontSize: "14px",
              transition: "color 0.3s ease",
            }}
            onMouseEnter={(e) => e.target.style.color = "#0056b3"}
            onMouseLeave={(e) => e.target.style.color = "#007bff"}
          >
            دانلود فایل {fileIndex + 1}
          </a>
        </div>
      ));
    })()}
  </>
)}


      {/* نمایش تیک فقط برای پیام‌های کاربر */}
      {message.sender === "user" && (
        <div
          onClick={() => toggleReadStatus(message)}
          style={{
            position: "absolute",
            top: "10px",
            right: "-25px",
            cursor: "pointer",
          }}
          title="تغییر وضعیت پیام"
        >
          {message.isRead === "seen" ? "✅" : "⬜"}
        </div>
      )}
    </div>
    <div style={{ fontSize: "0.8rem", color: "#888", marginTop: "5px" }}>
      {message.date} - {message.time}
    </div>
  </div>
))}




{contextMenu && (
  <div
    style={{
      position: "absolute",
      top: `${contextMenu.y}px`,
      
      backgroundColor: "#ffffff",
      border: "1px solid #ddd",
      borderRadius: "8px",
      zIndex: 1000,
      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
      minWidth: "160px",
      overflow: "hidden",
    }}
  >
    <button
      onClick={() => handleEditMessage(contextMenu.message)}
      style={{
        display: "block",
        width: "100%",
        padding: "10px 15px",
        cursor: "pointer",
        backgroundColor: "transparent",
        border: "none",
        textAlign: "right",
        fontSize: "14px",
        color: "#495057",
        transition: "background-color 0.3s",
      }}
      onMouseEnter={(e) => (e.target.style.backgroundColor = "#f8f9fa")}
      onMouseLeave={(e) => (e.target.style.backgroundColor = "transparent")}
    >
      🖊️ ویرایش
    </button>
    <button
      onClick={() => handleDeleteMessage(contextMenu.message)}
      style={{
        display: "block",
        width: "100%",
        padding: "10px 15px",
        cursor: "pointer",
        backgroundColor: "transparent",
        border: "none",
        textAlign: "right",
        fontSize: "14px",
        color: "#dc3545",
        transition: "background-color 0.3s",
      }}
      onMouseEnter={(e) => (e.target.style.backgroundColor = "#f8f9fa")}
      onMouseLeave={(e) => (e.target.style.backgroundColor = "transparent")}
    >
      🗑️ حذف
    </button>
  </div>
)}





                </div>
                
                )}
              </CardBody>
              <div style={{ padding: "10px", borderTop: "1px solid #ddd", display: "flex" ,
            
            opacity: isDisabled ? 0.5 : 1, // کاهش شفافیت هنگام غیرفعال بودن
    pointerEvents: isDisabled ? "none" : "auto", // جلوگیری از کلیک در حالت غیرفعال
    cursor: isDisabled ? "not-allowed" : "pointer", // تغییر نشانگر موس
            }}>
  <Button
    color={isRecording ? "danger" : "secondary"}
    onClick={isRecording ? stopRecording : startRecording}
    style={{ marginRight: "10px" ,
  
  }}
  >
    {isRecording ? "توقف ضبط" : "ضبط صوت"}
  </Button>

  <Input
    type="file"
    onChange={(e) => setSelectedFile(e.target.files[0])} // تنظیم فایل انتخاب‌شده
    style={{ display: "none" }} // مخفی کردن ورودی فایل
    id="file-input"
  />
  <label htmlFor="file-input">
    <FaPaperclip size={24} color="#495057" style={{ cursor: "pointer", marginRight: "10px" }} />
  </label>

  {selectedFile && (
    <div style={{ 
      display: "flex", 
      alignItems: "center", 
      marginRight: "10px",
      padding: "5px 10px",
      backgroundColor: "#f0f0f0",
      borderRadius: "5px",
      border: "1px solid #ddd"
    }}>
      <FaFileAlt size={16} color="#495057" style={{ marginLeft: "8px" }} />
      <span style={{ 
        fontSize: "12px", 
        color: "#495057",
        maxWidth: "150px",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }}>
        {selectedFile.name}
      </span>
      <Button 
        color="link" 
        onClick={() => {
          setSelectedFile(null);
          // ریست کردن input فایل
          const fileInput = document.getElementById("file-input");
          if (fileInput) {
            fileInput.value = "";
          }
        }}
        style={{ 
          padding: "0 5px",
          fontSize: "12px",
          color: "#dc3545",
          textDecoration: "none"
        }}
      >
        ✕
      </Button>
    </div>
  )}

  {audioUrl && (
    <div style={{ display: "flex", alignItems: "center", marginRight: "10px" }}>
      <audio controls src={audioUrl} style={{ marginRight: "10px" }} />
      <Button 
        color="danger" 
        onClick={discardVoiceMessage}
        disabled={isSendingVoice}
      >
        حذف
      </Button>
      <div style={{ position: "relative", minWidth: "120px", marginLeft: "10px" }}>
        <Button 
          color="primary" 
          onClick={handleSendVoiceMessage}
          disabled={isSendingVoice || isDisabled}
          style={{ width: "100%" }}
        >
          {isSendingVoice ? `${sendVoiceProgress}%` : "ارسال ویس"}
      </Button>
        {isSendingVoice && (
          <div
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              height: "4px",
              backgroundColor: "#2196f3",
              width: `${sendVoiceProgress}%`,
              transition: "width 0.3s ease",
              borderRadius: "0 0 4px 4px",
            }}
          />
        )}
      </div>
    </div>
  )}

  <Input
    type="text"
    placeholder="پیام خود را بنویسید..."
    value={newMessage}
    onChange={(e) => setNewMessage(e.target.value)}
    style={{ flex: 1, marginRight: "10px" }}
    disabled={isSending}
  />
  <div style={{ position: "relative", minWidth: "120px" }}>
    <Button 
      color="primary" 
      onClick={handleSendMessage}
      disabled={isSending || isDisabled}
      style={{ width: "100%" }}
    >
      {isSending ? `${sendProgress}%` : "ارسال"}
  </Button>
    {isSending && (
      <div
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          height: "4px",
          backgroundColor: "#2196f3",
          width: `${sendProgress}%`,
          transition: "width 0.3s ease",
          borderRadius: "0 0 4px 4px",
        }}
      />
    )}
  </div>
              </div>


              
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default TicketMessages;
